<template>
    <v-card min-width="21vw" align="center" justify="center" outlined>
        <v-card-title >
            <v-list-item>
                <v-list-item-title><h2>{{ $t('title_ShareLink') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 pt-7">
            <p class="mb-5">{{ $t('description_ShareLink') }}</p>
            <v-text-field  :label="$t('label_ShareLink')" v-model="link" id="textToCopy" readonly @click="copyText" outlined/>
            <v-btn @click="closeWindow">{{ $t('btnCopy') }}</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../../repositories/sharing';
    export default {
        name: "ShareLink",
        data() {
            return {
                link: '',
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                Repository.getShareLinkByUserId(this.$store.state.user.id).then((response) => {
                    if(response.status < 400) {
                        if(response.data != null && response.data.id !== undefined)
                            this.link = `https://app.swiset.com/share?id=${response.data.uniqueHash}`;
                        else {
                            let shareLink =  {
                                user: { id: this.$store.state.user.id },
                                allowComments: true,
                            };
                            Repository.createShareLink(shareLink).then((response) => {
                                if(response.status < 400)
                                    this.link = `https://app.swiset.com/share?id=${response.data.uniqueHash}`;
                            });
                        }
                    }
                });
            },
            copyText () {
                let textToCopy = document.getElementById("textToCopy");
                textToCopy.select();
                document.execCommand("copy");
            },
            closeWindow() {
                this.copyText();
                this.$emit('closeWindow');
            }
        },
    }
</script>



<style scoped>

</style>
